import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ToastController } from '@ionic/angular';

import { AuthenticationService, TranslateConfigService } from '../_services';

@Injectable()

export class ErrorInterceptor implements HttpInterceptor {

    constructor(
        private auth: AuthenticationService, 
        private router: Router,
        private toastController: ToastController, 
        private translateConfigService: TranslateConfigService,
    ) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(err => {
            const isExpiredToken =
                (err.status === 401 || err.status === 500) &&
                (err.error?.message === 'Expired token' || err.error?.error === 'Expired token');

            if (isExpiredToken) {
                this.toastController.create({
                    message: this.translateConfigService.getKey('GENERAL.sesion_expirada'),
                    duration: 2000
                }).then((toastData) => {
                    this.auth.logout();
                    this.router.navigate(['/tabs/inicio/home']);
                    toastData.present();
                });
            }

            return throwError(() => ({
                message: err.error?.message || err.error?.error || err.statusText,
                errors: err.error?.errors || null,
                code: err.error?.code || null,
                status: err.status
            }));
        }))
    }
}